export default __webpack_public_path__ + "static/media/screen_link.bcb075d7.svg";